import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';

const DividendsDistributionModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useDividendsDistributionModal();

  const buttonEnabledScriptureView = data.scriptureView && data.date;
  const buttonEnabledDataView = !data.scriptureView && data.totalAmount;

  const buttonText = data.scriptureView ? t('Next') : t('SaveOperation');

  return (
    <>
      <Modal.Footer>
        <div className="d-flex justify-content-between w-100">
          <button
            type="button"
            className="btn btn-lg btn-primary"
            onClick={actions.handleSaveDividends}
            disabled={!buttonEnabledScriptureView && !buttonEnabledDataView}
          >
            {buttonText}
          </button>
        </div>
      </Modal.Footer>
    </>
  );
};

export default DividendsDistributionModalFooter;
